export const footer = {
  "description": "Platforma wymiany domów między gospodarzami Airbnb. Podróżuj za darmo na całym świecie.",
  "company": "Firma",
  "about": "O nas",
  "howItWorks": "Jak to działa",
  "blog": "Blog",
  "careers": "Kariera",
  "support": "Wsparcie",
  "help": "Centrum pomocy",
  "contact": "Kontakt",
  "terms": "Warunki korzystania",
  "privacy": "Poufność",
  "community": "Społeczność",
  "members": "Członkowie",
  "destinations": "Miejsca docelowe",
  "events": "Wydarzenia",
  "newsletter": "Biuletyn",
  "newsletterText": "Otrzymuj nasze najnowsze oferty i aktualności",
  "emailPlaceholder": "Twój email",
  "newsletterSuccess": "Rejestracja udana!",
  "newsletterError": "Wystąpił błąd.",
  "newsletterInvalid": "Nieprawidłowy email.",
  "subscribe": "Zasubskrybuj",
  "rights": "Wszelkie prawa zastrzeżone",
  "madeWith": "Zrobione z",
  "by": "przez zespół DONKEY TRAVEL"
};
